import Store from "./Store";
import {Call} from "../../model/call.model";

export default class CallStore extends Store<Call> {
  protected override name: string = "calls";
}
